import flashAuctionImg from '../assets/images/flash_auction.png';
import livedAuctionImg from '../assets/images/lived_auction.png';
import timedAuctionImg from '../assets/images/timed_auction.png';
import onSiteAuctionImg from '../assets/images/onsite_auction.png';

export const howToAuction = [
  {
    newBadge: true,
    title: 'Flash Auction',
    description:
      'Peserta dapat mengikuti lelang online dimana saja, dengan fitur live streaming dan live chat untuk mengecek kondisi kendaraan. Eksklusif hanya melalui Aplikasi Mobile sesuai rentang waktu yang telah ditentukan.',
    imgUrl: flashAuctionImg,
    urlLink: 'https://www.ibid.astra.co.id/flash-auction',
  },
  {
    newBadge: false,
    title: 'Live Auction',
    description:
      'Peserta dapat mengikuti lelang melalui Website dan Aplikasi mobile sesuai jadwal yang telah ditentukan di lokasi balai lelang yang tersebar di berbagai wilayah di seluruh Indonesia tanpa harus datang ke lokasi lelang.',
    imgUrl: livedAuctionImg,
    urlLink: 'https://www.ibid.astra.co.id/prosedur/cara-live-auction',
  },
  {
    newBadge: false,
    title: 'Timed Auction',
    description:
      'Peserta dapat mengikuti lelang secara online dari mana saja eksklusif melalui aplikasi IBID tanpa harus hadir dilokasi. Lelang berlangsung selama rentang waktu tertentu bisa beberapa jam atau beberapa hari.',
    imgUrl: timedAuctionImg,
    urlLink: 'https://www.ibid.astra.co.id/prosedur/cara-timed-auction',
  },
  {
    newBadge: false,
    title: 'Onsite Auction',
    description:
      'Peserta dapat langsung melakukan penawaran atau bidding di lokasi balai lelang IBID yang tersebar di berbagai wilayah di seluruh Indonesia sesuai jadwal yang telah ditentukan lokasi lelang.',
    imgUrl: onSiteAuctionImg,
    urlLink: 'https://www.ibid.astra.co.id/prosedur/cara-lelang-onsite',
  },
];
